import { injectable } from 'inversify';

import { CreateCompanyGroupResponseItem } from '@app/gen/settings';
import { CompanyItem } from '@app/gen/candidates';

@injectable()
export class GroupNotificationsService {
  convertCompaniesToNotifications(
    responseCompanies: CreateCompanyGroupResponseItem[],
    allCompanies: CompanyItem[],
  ): {
    success: boolean;
    message: string;
  }[] {
    const result: { success: boolean; message: string }[] = [];

    if (responseCompanies.length === 1) {
      result.push({
        success: responseCompanies[0].success,
        message: responseCompanies[0].success
          ? 'Роль добавлена!'
          : 'Не удалось добавить роль!',
      });
    } else if (responseCompanies.length > 1) {
      const successes = responseCompanies.filter(({ success }) => success);

      if (successes.length > 0) {
        result.push({
          success: true,
          message: `Роль добавлена! Компании (${successes.length} шт)`,
        });
      }

      const companyNames = allCompanies.reduce(
        (acc: Record<string, string>, { id, name }) => {
          acc[id] = name;
          return acc;
        },
        {},
      );

      const failCompanyNames = responseCompanies
        .filter(({ success }) => !success)
        .map(({ company_id }) => companyNames[company_id])
        .join(', ');

      if (failCompanyNames) {
        result.push({
          success: false,
          message: `Не удалось добавить роль! Компании: ${failCompanyNames}`,
        });
      }
    }

    return result;
  }
}
